import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { SuccessAnimationComponent } from "./success-animation/success-animation.component";

const DIRECTIVES = [SuccessAnimationComponent];

@NgModule({
	imports: [CommonModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class AnimatedIconsModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
